import React from 'react';
import { CircleLoader } from '@hpstellar/core';

import './loader-overlay.less';

/**
 * A wrapper component that shows a loading spinner overly above the child component
 */
export default ({ children, isLoading }) => {
    return (
        <div className={`loader-overlay${isLoading ? ` loading` : ``}`}>
            {isLoading && <CircleLoader className="loader-spinner" />}
            {children}
        </div>
    );
};
